import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import logo from "@/assets/logo-horizontal-orange.svg"
import { useAuth } from "@/modules/Auth/context/AuthContext"
import { Input } from "@/components/ui/input"
import { authenticate } from "@/modules/Auth/service/AuthServices"
import { Icon } from "@/components/Atoms/Icon"

export default function BackofficeLogin() {
  const [password, setPassword] = useState<string>("")
  const [showPassword, setShowPassword] = useState(false) // 1. Estado para visibilidade
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const email = searchParams.get("email")
  const token = searchParams.get("token")
  const { plataformaResetSenha } = useAuth()

  const handleSetNewPass = async () => {
    setLoading(true)
    plataformaResetSenha(email, password, token)
      .then(() => {
        navigate("/dashboard")
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (localStorage.getItem("token") && localStorage.getItem("user")) {
      return
    }

    authenticate()
      .then(({ authData }) => {
        localStorage.setItem("token", authData.access_token)
      })
      .catch((error) => {
        console.error("Authentication failed:", error)
      })
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md space-y-8">
        <div className="space-y-6 rounded-xl bg-zinc-800/70 p-8">
          <div className="flex justify-center">
            <img
              src={logo}
              alt="Giants"
              width="50%"
            />
          </div>

          <div className="space-y-2 text-center">
            <p className="text-sm text-muted-foreground">Painel Administrativo</p>
          </div>

          <div className="space-y-6">
            <div className="space-y-2 text-center">
              <i className="fi fi-ts-shield-check text-4xl text-primary"></i>
              <h2 className="text-lg font-semibold text-foreground">Redefina sua senha</h2>
              <p className="text-sm text-muted-foreground">Digite uma nova senha</p>
            </div>

            {/* 2. Container relativo para posicionar o ícone */}
            <div className="relative flex items-center">
              <Input
                onChange={(e) => setPassword(e.target.value)}
                // 3. Tipo dinâmico baseado no estado
                type={showPassword ? "text" : "password"}
                className="h-12 border-border bg-surface pr-12 text-2xl tracking-widest text-foreground"
                placeholder="*********"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 flex h-full items-center text-muted-foreground transition-colors hover:text-primary"
              >
                <Icon name={!showPassword ? "crossed-eye" : "eye"} />
              </button>
            </div>

            <button
              onClick={() => handleSetNewPass()}
              disabled={loading}
              className="transition-smooth w-full rounded-lg bg-primary py-3 font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
            >
              {loading ? "Enviando..." : "Enviar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
